<template>
  <IconButton
    icon="mdi-location-exit"
    :tooltip-text="$t('LogOut')"
    button-class="ml-3"
    @click="handleLogout"
  />
</template>

<script>
import IconButton from './IconButton.vue';

export default {
  name: 'LogoutButton',
  components: {
    IconButton
  },
  methods: {
    handleLogout() {
      this.$store.dispatch('logout', { vm: this }).then(() => {
        this.$router.push('/login');
      });
      // прячем форму ввода пароля, если его вводил и решил разлогиниться (иначе она потом всплывает, когда авторизуешься)
      this.$emit('hidePasswordForm');
    }
  }
};
</script>
